// ===== UTILITY FUNCTIONS =====

/**
 * Format milliseconds to MM:SS format
 * @param {number} ms - Time in milliseconds
 * @returns {string} Formatted time string
 */
export function formatTime(ms) {
    if (!Number.isFinite(ms) || ms < 0) ms = 0;
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

/**
 * Clamp a value between min and max
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
export function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}

/**
 * Show error message
 * @param {string} message - Error message to display
 * @param {number} duration - How long to show (ms)
 */
export function showError(message, duration = 5000) {
    const errorEl = document.getElementById('error-message');
    if (!errorEl) return;

    errorEl.textContent = message;
    errorEl.removeAttribute('hidden');

    setTimeout(() => {
        errorEl.setAttribute('hidden', '');
    }, duration);
}

/**
 * Show loading spinner
 */
export function showLoading() {
    const spinner = document.getElementById('loading-spinner');
    if (spinner) spinner.removeAttribute('hidden');
}

/**
 * Hide loading spinner
 */
export function hideLoading() {
    const spinner = document.getElementById('loading-spinner');
    if (spinner) spinner.setAttribute('hidden', '');
}

/**
 * Escape HTML special characters
 * @param {string} text
 * @returns {string}
 */
export function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text ?? '';
    return div.innerHTML;
}
